var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E95420",
    d: "M104.663 0H24v128h80.663V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.443 90.31c4.611 0 8.35-3.768 8.35-8.416 0-4.648-3.739-8.416-8.35-8.416-4.612 0-8.35 3.768-8.35 8.416 0 4.648 3.738 8.416 8.35 8.416Zm34.778-18.454c4.612 0 8.35-3.768 8.35-8.416 0-4.648-3.738-8.416-8.35-8.416-4.611 0-8.35 3.768-8.35 8.416 0 4.648 3.739 8.416 8.35 8.416Zm-15.945 31.702c-6.016-1.299-11.042-5.17-13.868-10.662a11.934 11.934 0 0 1-7.14.883c3.419 8.464 10.67 14.611 19.573 16.535 1.953.422 3.943.627 5.93.614a12.107 12.107 0 0 1-2.444-7.037 20.048 20.048 0 0 1-2.048-.336l-.003.003Zm14.066 8.461c4.612 0 8.35-3.768 8.35-8.416 0-4.648-3.738-8.416-8.35-8.416-4.611 0-8.35 3.768-8.35 8.416 0 4.648 3.739 8.416 8.35 8.416Zm11.62-11.507c2.597-3.3 4.426-7.2 5.305-11.344a27.771 27.771 0 0 0-3.937-20.963 12.1 12.1 0 0 1-4.695 5.542 20.736 20.736 0 0 1 1.93 13.975 20.658 20.658 0 0 1-2.597 6.521 12.092 12.092 0 0 1 3.997 6.272l-.003-.003ZM41.8 69.824a11.785 11.785 0 0 1 3.156.256c1.361.294 2.64.813 3.812 1.549 3.76-5.45 9.826-8.72 16.399-8.842a12.213 12.213 0 0 1 2.534-6.826c-10.503-.838-20.708 4.625-25.905 13.866l.003-.003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.6cbf41b50c60cde1e5ef50042a55fdd8.svg";
export { ForwardRef as ReactComponent };